export const phoneSanitizer = (value: string) =>
  value
    .trim()
    .replaceAll(/[^0-9+]/g, '')
    .replace('+34', '');

export const spacesSanitizer = (value: string) => value.replace(/\s/g, '');
